import { render, staticRenderFns } from "./table-text.vue?vue&type=template&id=2efbda3d"
import script from "./table-text.vue?vue&type=script&lang=ts"
export * from "./table-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efbda3d')) {
      api.createRecord('2efbda3d', component.options)
    } else {
      api.reload('2efbda3d', component.options)
    }
    module.hot.accept("./table-text.vue?vue&type=template&id=2efbda3d", function () {
      api.rerender('2efbda3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-text.vue"
export default component.exports